const shared = {
  "app_id" : window.aId,
  "api_key": window.aKey,
  "env": window.env
};

const generatorsConfig = {
  ...shared,
  "index" : window.aGeneratorsIndex,
  "facets": [
    'productType'
  ]
};

const siteConfig = {
  ...shared,
  "index" : window.aSiteIndex,
};


export { generatorsConfig, siteConfig }
